<script>
  import EmailSignature from './components/EmailSignature.svelte'
</script>

<main>
  <EmailSignature />
</main>

<style>
  main {
    margin: 0;
    padding: 20px;
  }
</style>
